import { useState, useMemo } from "react";
import { Layout, Row, Col } from "antd";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Sidebar from "./components/menu/Sidebar";
import MenuHeader from "./components/header";
import ScrollTop from "./components/scroll-to-top";

const { Content } = Layout;

// Map route segments to page titles
const getPageTitle = (pathname: string): string => {
  // Extract the last meaningful segment from the path
  const segments = pathname.split("/").filter(Boolean);

  // Find the relevant segment (skip workspace ID and other identifiers)
  let pageSegment = "";
  for (let i = segments.length - 1; i >= 0; i--) {
    const segment = segments[i];
    // Skip UUIDs, IDs, and admin route identifiers
    if (
      !segment.match(
        /^[a-f0-9]{24}$|^[a-f0-9-]{36}$|^ws$|^a$|^sa$|^m$|^ma$/i
      ) &&
      segment.length > 2
    ) {
      pageSegment = segment;
      break;
    }
  }

  // Map segments to titles for Copilotly
  const titleMap: Record<string, string> = {
    dashboard: "Dashboard",
    copilots: "Copilots",
    builder: "Copilot Builder",
    customize: "Customize Copilot",
    share: "Share Copilot",
    analytics: "Analytics",
    chats: "Chats",
    metrics: "Metrics",
    team: "Team",
    workspace: "Workspace",
    api: "API Settings",
    integrations: "Integrations",
    profile: "My Profile",
    security: "Security",
    password: "Password",
    subscription: "Subscription",
    plans: "Plans",
    admins: "Admins",
    users: "Users",
    settings: "Settings",
    billing: "Billing",
    credits: "Credits",
    refills: "Refills",
    coupons: "Coupons",
    config: "AI Config",
    "ai-config": "AI Config",
    emails: "Emails",
    campaigns: "Campaigns",
    sequences: "Sequences",
    templates: "Templates",
    blogs: "Blogs",
    categories: "Categories",
    tags: "Tags",
    changelogs: "Changelogs",
    seo: "SEO Campaigns",
    pulse: "Pulse Reports",
  };

  const title = titleMap[pageSegment.toLowerCase()] || "Dashboard";
  return `${title} | Copilotly`;
};

const VerticalLayout = (props: any) => {
  const { children } = props;
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Get dynamic page title based on current route
  const pageTitle = useMemo(
    () => getPageTitle(location.pathname),
    [location.pathname]
  );

  return (
    <Layout className="hp-app-layout">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Sidebar visible={visible} setVisible={setVisible} />

      <Layout className="hp-bg-color-dark-90">
        <Content className="hp-content-main">
          <div className="menu_header__hamburger">
            <MenuHeader setVisible={setVisible} />
          </div>

          <Row justify="center">
            <Col span={24}>{children}</Col>
          </Row>
        </Content>
      </Layout>

      <ScrollTop />
    </Layout>
  );
};

export default VerticalLayout;
